<template lang="pug">
modal(:max-width="300")
	.card.text-left
		.card-header.bg-info
			span.fa.fa-print.mr-2
			| Menú de impresión
			button.close(@click="cerrar()") &times;
		.card-body
			.form-group
				label
					b Impresora
					select.form-control(v-model="impresion.ImpresoraID")
						option(
							v-for="(impresora, i) in impresoras"
							:key="i+1"
							:value="i+1"
						) {{impresora}}
			hr
			b Opciones
			div.opciones
				label
					input(type="checkbox", v-model="impresion.Color")
					| Color
				label
					input(type="checkbox", v-model="impresion.DobleCara")
					| Doble cara
				label
					input(type="checkbox", v-model="impresion.Collate")
					| Agrupar
				label
					input(type="checkbox", v-model="impresion.Landscape")
					| Horizontal
			.form-group
				label
					b Nº copias
				input.form-control(v-model.number="impresion.Copias", placeholder="1")
		.card-footer
			button.btn.btn-sm.btn-primary(@click="imprimir", :disabled="!impresion.ImpresoraID")
				span.fa.fa-print.mr-2
				| Imprimir
</template>

<script>
// import axios from 'axios'
export default {
	props: ['color', 'dobleCara', 'impresora'],
	data () {
		return {
			impresion: {
				ImpresoraID: null,
				Color: false,
				DobleCara: false,
				Collate: false,
				Landscape: false,
				Copias: 1
			},
			impresoras: ['Comercial', 'Multifunción', 'Informativos']
		}
	},
	created () {
		this.impresion.Color = this.color
		this.impresion.DobleCara = this.dobleCara
		// this.getImpresoras()
	},
	methods: {
		/* getImpresoras () {
			axios.get('core/php/api/impresoras/get.php')
				.then(res => {
					this.impresoras = res.data

					if (this.impresora) {
						this.impresion.ImpresoraID = this.impresoras.reduce((ant, actual) => {
							if (actual.Nombre === this.impresora) {
								ant = actual.ImpresoraID
							}
							return ant
						}, null)
					}
				})
				.catch(this.$responseError)
		}, */
		imprimir () {
			this.$emit('imprimir', this.impresion)
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
.opciones > label {
	position: relative;
	display: block;
	margin-top: 10px;
	cursor: pointer;
}

.opciones > label > input {
	margin-right: 15px;
}
</style>




// WEBPACK FOOTER //
// src/modulos/core/vue/components/imprimir/imprimir.vue